import type { JSX } from "react";
import type { LoomRunBlock as LoomRunBlockModel } from "@shared/types";
import type { BlockRendererProps } from "./registry";
import { BlockRenderer } from "../loom-replay/block-renderer";
import "../../../styles/loom.css";

/**
 * Persisted "Try it yourself" run (LOOM_LIVE L-2). Overlaid onto the turn from a
 * loom-run annotation (openspec/loom-live-persistence.md), so it survives reload.
 * Renders the run's block snapshot through the SAME loom replay views, so a
 * reloaded run looks as it did live. `running` (a reload mid-run) shows a note.
 */
export function LoomRunBlockView({ block }: BlockRendererProps): JSX.Element {
  const run = block as LoomRunBlockModel;
  const head =
    run.status === "running"
      ? "在你的织灵里执行中…"
      : run.status === "done"
        ? "在你的织灵里跑过 · 已完成"
        : run.status === "stopped"
          ? "已停止"
          : "织灵这次没跑完";
  const dot = run.status === "running" ? "running" : run.status === "error" ? "error" : "";
  return (
    <div className="loom-runcard">
      <div className="loom-runhead">
        <span className={`loom-rundot ${dot}`} />
        {head}
      </div>
      {run.blocks !== undefined && run.blocks.length > 0 ? (
        // replay-block-card provides the loom block CSS (vars + icon sizing).
        <div className="loom-runbody replay-block-card">
          {run.blocks.map((b) => (
            <BlockRenderer key={b.id} block={b} />
          ))}
        </div>
      ) : (
        <div className="loom-runnote">
          {run.status === "running" ? "可能仍在你的织灵里跑;完成后这里会显示结果。" : "（没有可显示的结果）"}
        </div>
      )}
    </div>
  );
}
